import { action } from "typesafe-actions";
import { Branch, BranchActionTypes, Data } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown
) => action(BranchActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data: Branch) =>
  action(BranchActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(BranchActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: Branch | null) => unknown
) => action(BranchActionTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: Branch) =>
  action(BranchActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(BranchActionTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id: string,
  callback?: (error: string | null) => unknown
) => action(BranchActionTypes.DELETE_REQUEST, { id, callback });

export const deleteSuccess = () => action(BranchActionTypes.DELETE_SUCCESS);

export const deleteError = (error: string) =>
  action(BranchActionTypes.DELETE_ERROR, error);
